export const countDown = (data) => {
  // 间隔时间毫秒转成秒
  // var remTime = (data - new Date()) / 1000;
  var remTime = Number(data);
  if (remTime <= 0) return "00:00:00";
  // 满足一天及天数加1 不满足则为余数 所以直接除一天有多少秒即可
  // var days = parseInt(remTime / 60 / 60 / 24);
  // 先算出剩余时间有多少小时，这些小时有多少个24小时 不满24小时的及为剩余多少小时
  var hour = parseInt((remTime / 60 / 60) % 24);
  // 换算 多少分钟 满足60分的为小时数 不满60分的及为剩余分钟数
  var min = parseInt((remTime / 60) % 60);
  // 满足60秒的为分钟数 不满60秒的及为剩余秒数
  var sec = parseInt(remTime % 60);
  hour = hour < 10 ? "0" + hour : hour;
  min = min < 10 ? "0" + min : min;
  sec = sec < 10 ? "0" + sec : sec;
  return `${hour}:${min}:${sec}`;
};

export const typeText = (data) => {
  let array = /^(.+)\|(.+)\(([\u4e00-\u9fa5]+)\)$/.exec(data);

  return array || [];
};

export const typeRate = (data) => {
  if (Array.isArray(data)) {
    return data.map((item) => {
      switch (item.rarityName || item.rarity) {
        case "隐秘":
        case "非凡":
        case "违禁":
          item.class = "sssr";
          break;
        case "保密":
          item.class = "ssr";
          break;
        case "受限":
          item.class = "sr";
          break;
        case "工业级":
        case "军规级":
          item.class = "r";
          break;
        case "消费级":
          item.class = "n";
          break;
        default:
          item.class = "n";
      }
      if (item.inventoryState === "processing") {
        item.active = true;
      } else {
        item.active = false;
      }
      if (new Date(item.timeCreate).getTime() > new Date().getTime()) {
        item.timeCreate = formatDate();
      }
      return item;
    });
  } else {
    switch (data.rarityName) {
      case "隐秘":
      case "非凡":
      case "违禁":
        data.class = "sssr";
        break;
      case "保密":
        data.class = "ssr";
        break;
      case "受限":
        data.class = "sr";
        break;
      case "工业级":
      case "军规级":
        data.class = "r";
        break;
      case "消费级":
        data.class = "n";
        break;
      default:
        data.class = "n";
    }
    data.names = typeText(data.awardName);
    return data;
  }
};

export const rarityRate = (data) => {
  let string = JSON.stringify(data);
  string = string.replace(/隐秘|非凡|违禁/g, "sssr");
  string = string.replace(/保密/g, "ssr");
  string = string.replace(/受限/g, "sr");
  string = string.replace(/军规级|工业级/g, "r");
  string = string.replace(/消费级/g, "n");

  return JSON.parse(string);
};

export const GetItemDuration = (data) => {
  let item = data.match(/^(.*?)\s?(\(.*\))?$/)[2];
  if (item) return item.replace("(", "").replace(")", "");
  return "其他物品";
};

export const getBrackets = (data) => {
  let item = data.match(/\（.*?\）/);
  if (item) return item[0];
  return null;
};

export const getFirstName = (data) => {
  let item = data.match(/.*(?=（)/) || data.match(/.*(?= \|)/);
  if (item) return item[0];
  return null;
};

export const GetItemName = (data) => {
  let item = data.match(/^(.*?)\s?(\(.*\))?$/)[1];
  var array = item.split("|");
  if (array.length >= 2) return array[0];
  return item;
};

export const GetItemSkinName = (data) => {
  let item = data.match(/^(.*?)\s?(\(.*\))?$/)[1];
  var array = item.split("|");
  if (array.length >= 2) return array[1];
  return "原皮";
};

export const timeToCounter = (data) => {
  var nowTime = +new Date();
  //获取输入时间的毫秒数
  var putTime = +new Date(data);
  //剩余时间总的毫秒数 除以 1000 变为总秒数
  var dec = (putTime - nowTime) / 1000;
  //得到天 格式化成前缀加零的样式
  var d = parseInt(dec / 60 / 60 / 24);
  d = d < 10&&d > 10 ? "0" + d : d;
  //得到小时 格式化成前缀加零的样式
  var h = parseInt((dec / 60 / 60) % 24);
  h = h < 10&&d > 10 ? "0" + h : h;
  //得到分钟 格式化成前缀加零的样式
  var m = parseInt((dec / 60) % 60);
  m = m < 10&&d > 10 ? "0" + m : m;

  //得到秒 格式化成前缀加零的样式
  var s = parseInt(dec % 60);
  s = s < 10&&d > 10 ? "0" + s : s;
  return `${d}日：${h}时：${m}分`;
};

//倒计时
export const countDownS = (data) => {
  let indexTime = new Date();
  let netxTime = new Date(data);
  let s = Math.floor((netxTime - indexTime) / 1000);
  let day = Math.floor(s / 60 / 60 / 24);
  let hour = Math.floor((s / 60 / 60) % 24);
  let minute = Math.floor((s / 60) % 60);
  hour = hour < 10 ? "0" + hour : hour;
  minute = minute < 10 ? "0" + minute : minute;
  if (day > 0) {
    if (hour === "00") {
      return `${day}天`;
    } else {
      return `${day}天${hour}小时`;
    }
  } else {
    if (hour === "00") {
      return `${minute}分钟`;
    } else {
      return `${hour}小时`;
    }
  }
};

//页面滚动到指定位置--edge\ie\safari\iso没有滚动效果
export const roll = (data) => {
  if (/^#.+$/.test(data)) {
    let element = document.querySelector(data);
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  } else {
    document.documentElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }
};

function fomatFloat(num) {
  num = num.toFixed(3);
  num = num.substr(0, num.length - 1);

  return num;
}
export const addZero = (data) => {
  let val = String(data);
  let zeroList=[];
  if (val.length < 5) {
    for (let index = 0; index < Number(5 - val.length); index++) {
        zeroList.push(0);
    }
    val = `${zeroList.join("")}${data}`;
  }
  return val;
};
//价格换算
export const conversion = (data) => {
  return fomatFloat(data);
};

//图片转换
export const imgfilter = (data) => {
  if (!data) return "";

  if (data.toLowerCase().startsWith("/uploads/")) {
    return window.configs.imgbaseURL + data;
  }
  if (data.toLowerCase().startsWith("/upload/")) {
    return "https://jhskins.com" + data;
  }
  return data;
};

//取回Ids
export const Ids = (data) => {
  if (Array.isArray(data)) {
    let str = "?";
    data.forEach((item) => {
      str += `ids=${item}&`;
    });
    return str;
  } else {
    return "";
  }
};

//状态码提示过滤
export const msgToast = (data) => {
  switch (data) {
    case 0:
      return "Steam机器人正在向您发送饰品";
    case 1:
      return "您已成功接受饰品,点此关闭";
    case 9:
      return "饰品报价已超时，Steam自动取消。请您重新进行兑换";
    case 10:
      return "Steam机器人发送饰品成功，点击前往接受 >>";
    case 11:
      return "您已接受饰品，等待Steam确认中";
    case 12:
      return "您更改了报价，交易自动失效";
    case 13:
      return "您主动拒绝了饰品报价，请您重新进行兑换";
    case 500:
    case 604:
    case 715:
    case 725:
    case 728:
    case 732:
    case 733:
    case 734:
      return `Steam服务器错误，请联系客服处理(E${data})`;
    case 505:
      return `存入已成功，但Steam回应出错。请联系客服处理(E${data})`;
    case 600:
      return `您的Steam库存未公开,请点此公开库存后重试(E${data})`;
    case 601:
      return `您的账号无法交易，请参照取回教程绑定令牌后再试(E${data})`;
    case 602:
      return `您的交易Url错误，请点此重新设置后再试(E${data})`;
    case 603:
      return `您的交易Url已失效，请点此重新设置后再试(E${data})`;
    case 702:
    case 711:
    case 700:
    case 716:
    case 720:
    case 730:
    case 731:
    case 741:
      return `Steam服务器错误，请稍后再次取回(E${data})`;
    default:
      return `未知错误(E${data})`;
  }
};

export const getDateString = (data) => {
  return formatDate(data);
};

export const formatDate = (
  obj = { string: "YYYY-MM-DD hh:mm:ss", date: new Date() }
) => {
  //{string,date}
  //格式化日期对象
  //YYYY 2019
  //MM    11
  //DD    04
  //hh    10
  //mm    00
  //ss    00
  //YYYY-MM-DD hh:mm:ss 2019-11-04 10:00:00
  //YYYY-MM 2019-11
  //YYYY-MM-DD 2019-11-04
  //hh:mm:ss  10:00:00
  let { string, date } = obj;
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hour = date.getHours();
  let min = date.getMinutes();
  let sec = date.getSeconds();
  month = month < 10 ? "0" + month : month;
  day = day < 10 ? "0" + day : day;
  hour = hour < 10 ? "0" + hour : hour;
  min = min < 10 ? "0" + min : min;
  sec = sec < 10 ? "0" + sec : sec;
  switch (string) {
    case "YYYY":
      string = year;
      break;
    case "MM":
      string = month;
      break;
    case "DD":
      string = day;
      break;
    case "hh":
      string = hour;
      break;
    case "mm":
      string = min;
      break;
    case "ss":
      string = sec;
      break;
    case "YYYY-MM":
      string = `${year}-${month}`;
      break;
    case "YYYY-MM-DD":
      string = `${year}-${month}-${day}`;
      break;
    case "YYYY-MM-DD hh:mm:ss":
      string = `${year}-${month}-${day} ${hour}:${min}:${sec}`;
      break;

    default:
      string = `${year}-${month}-${day} ${hour}:${min}:${sec}`;
      break;
  }
  return string;
};

import store from "../store.js";

//官网相关

//遮罩加载
const set_official_loading = (v) => {
  store.commit("set_official_loading", v);
};

//刮刮乐数量
const set_scrape = () => {
  if (sessionStorage.getItem("renew")) {
    let list = JSON.parse(sessionStorage.getItem("renew"));
    store.commit("set_scrape", list.length);
  }
};

//弹框
const set_messageData = (v) => {
  store.commit("set_messageData", v);
};

export { set_official_loading, set_scrape, set_messageData ,  _sub,
    _div,
    _mul };

function _add(a, b) {
    let r1, r2, m;
    try { r1 = a.toString().split(".")[1].length; } catch (e) { r1 = 0; }
    try { r2 = b.toString().split(".")[1].length; } catch (e) { r2 = 0; }
    m = Math.pow(10, Math.max(r1, r2));
    return (a * m + b * m) / m;
}

function _sub(a, b) {
    let r1, r2, m, n;
    try { r1 = a.toString().split(".")[1].length; } catch (e) { r1 = 0; }
    try { r2 = b.toString().split(".")[1].length; } catch (e) { r2 = 0; }
    m = Math.pow(10, Math.max(r1, r2));
    n = (r1 >= r2) ? r1 : r2;
    return ((a * m - b * m) / m).toFixed(n);
}

function _mul(a, b) {
    let m = 0;
    const s1 = a.toString();
    const s2 = b.toString();
    try { m += s1.split(".")[1].length; } catch (e) { }
    try { m += s2.split(".")[1].length; } catch (e) { }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}

function _div(a, b) {
    let t1 = 0, t2 = 0;
    try { t1 = a.toString().split(".")[1].length; } catch (e) { }
    try { t2 = b.toString().split(".")[1].length; } catch (e) { }
    const r1 = Number(a.toString().replace(".", ""));
    const r2 = Number(b.toString().replace(".", ""));
    return (r1 / r2) * Math.pow(10, t2 - t1);
}

